module.exports = __webpack_public_path__ + "img/header-weddingRingsFacettedConnections@2x.07e0a86.webp";